export default __webpack_public_path__ + "static/media/12.caff2479.jpg";